import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { AccessComponentEnum, AccessLevelEnum, Sector } from 'graphql-common';
import BreadCrumbs from '@lib/components/BreadCrumbs/BreadCrumbs';
import { getBreadCrumbsDataByKey } from 'utils/breadcrumbs';
import useOutletContext, { ContextProps } from 'hooks/useOutletContext';
import { Modals } from '@lib/enums/modals';
import useModalManagement from '@lib/hooks/useModalManagement';
import { useTableItemsBulkSelect } from '@lib/hooks/useTableItemsBulkSelect';
import useActions from './utils/useActions';
import SectorList from './SectorList';

const modals = [Modals.DestroyModal];

function SectorsContainer() {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const useBulkSelectResult = useTableItemsBulkSelect<Sector>();

  const { getUserAccessByComponent }: ContextProps = useOutletContext();
  const isViewOnly =
    getUserAccessByComponent(AccessComponentEnum.SitesManagement) ===
    AccessLevelEnum.Read;

  const useModalManagementResult = useModalManagement(modals);

  const useActionsResult = useActions({
    useModalManagementResult,
    useBulkSelectResult,
  });

  return (
    <>
      <BreadCrumbs data={getBreadCrumbsDataByKey({ pathname, t })} />
      <SectorList
        useModalManagementResult={useModalManagementResult}
        useActionsResult={useActionsResult}
        useBulkSelectResult={useBulkSelectResult}
        isViewOnly={isViewOnly}
      />
    </>
  );
}

export default SectorsContainer;
